import React, { memo, useContext, useEffect, useRef, useState } from 'react';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import { useSelector } from 'react-redux';
import { ChevronLeft, ChevronRight } from '@yme/assets/icons';
import { BTN_DARK_THEME, FADED_VARIANT, ICON_ONLY, SIZE_48 } from '@yme/atoms/button';
import { useLightbox } from '@yme/atoms/lightbox';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getProductCardLabels, selectProductCardData } from '@yme/pdp-components/ProductCard';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { onOpenWindow } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { GalleryContext as DefaultGalleryContext } from './GalleryContext';
import { GalleryList } from './GalleryList';
import { GalleryThumbnails } from './GalleryThumbnails';
import { InfoContainer } from './InfoContainer';
import { IMAGE } from './constants';
import { ControlButtonStyled, GalleryContainerStyled, GalleryCounter, GalleryItemContainerStyled, GalleryTrackStyled, } from './styled';
import { useErrorItems } from './useErrorItems';
import { useGalleryHandlers } from './useGalleryHandlers';
function GalleryComponent({ photoDisclaimers, view360BtnRef, config: { isExpandAvailable, isControlsAvailable = false, thumbnailsAmount, thumbnailsIndent, hasPadding = false, isInLightbox = false, isSquareRatio = false, }, initialIndex = 0, isZoomed = false, context = DefaultGalleryContext, thumbnailAspectRatio = AspectRatio.RectangleLevel3, }) {
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isNextVisible, setIsNextVisible] = useState(true);
    const [isPrevVisible, setIsPrevVisible] = useState(true);
    const [isItemLast, setIsItemLast] = useState(false);
    const [isItemFirst, setIsItemFirst] = useState(false);
    const galleryTrackRef = useRef(null);
    const isRightToLeft = useSelector(getRTL);
    const { titleAttribute } = useSelector(selectProductCardData);
    const productCardLabels = useSelector(getProductCardLabels);
    const galleryTrackElement = galleryTrackRef?.current;
    const { common_nextGalleryItemButton_alt: next, common_previousGalleryItemButton_alt: previous, common_download_label: downloadButtonLabel, common_close_label: close, } = useSelector(getCommonLabels);
    const { galleryData: { imagesList = [], lightboxImagesList = [], lightboxThumbnails = [], thumbnailsList = [], }, setCurrentId, } = useContext(context);
    const { isInfiniteDesktopView } = useWindowSize();
    const galleryData = isInLightbox ? lightboxImagesList : imagesList;
    // if component is used outside of PDP, we don't have productCardLabels
    const titlePostfix = productCardLabels.productCard_gallery_label ?? '';
    const labels = {
        title: `${titleAttribute?.value ?? ''} ${titlePostfix}`.trim(),
        previous,
        next,
        downloadButtonLabel,
        close,
    };
    const { openLightbox, Lightbox } = useLightbox(labels, isRightToLeft, context);
    const { addErrorItem, isErrorItem } = useErrorItems();
    const isOpenLightboxAvailable = currentIndex !== null &&
        isExpandAvailable &&
        Boolean(galleryData?.length) &&
        !isErrorItem(currentIndex);
    const { showPrev, showNext, showItem, touchStartHandler, touchMoveHandler, pointerDownHandler, pointerUpHandler, keyPressHandler, isView360State, isDraggable, } = useGalleryHandlers(context, isRightToLeft, isItemFirst, isItemLast, isOpenLightboxAvailable, openLightbox, currentIndex, setCurrentIndex, view360BtnRef);
    const onDownloadImage = (url) => {
        onOpenWindow(url);
    };
    useEffect(() => {
        setCurrentIndex(initialIndex);
    }, [galleryData, initialIndex]);
    useEffect(() => {
        if (currentIndex !== null) {
            setIsItemFirst(currentIndex <= 0);
            setIsItemLast(currentIndex >= galleryData.length - 1);
        }
    }, [currentIndex, galleryData]);
    useEffect(() => {
        setIsPrevVisible(isRightToLeft ? !isItemLast : !isItemFirst);
        setIsNextVisible(isRightToLeft ? !isItemFirst : !isItemLast);
    }, [isItemFirst, isItemLast, isRightToLeft]);
    useEffect(() => {
        if (galleryTrackElement) {
            galleryTrackElement.focus();
        }
    });
    useEffect(() => {
        if (currentIndex === null || currentIndex < 0) {
            return;
        }
        const id = galleryData[currentIndex]?.id ?? '';
        setCurrentId(id);
    }, [currentIndex, galleryData, setCurrentId]);
    if (currentIndex === null || !galleryData) {
        return null;
    }
    const currentImageURL = galleryData[currentIndex]?.element?.props?.src ?? '';
    const isImage = galleryData[currentIndex]?.elementType === IMAGE || galleryData[currentIndex]?.type === IMAGE;
    const isVideo = Boolean(galleryData[currentIndex]?.element?.props['videoPath']);
    return (React.createElement(GalleryContainerStyled, { isInLightbox: isInLightbox },
        React.createElement(InfoContainer, { amount: galleryData?.length, currentItem: currentIndex + 1, isInLightbox: isInLightbox, isImage: isImage, isMobile: true, downloadButtonLabel: downloadButtonLabel, onDownload: () => onDownloadImage(currentImageURL), isRightToLeft: isRightToLeft }),
        !isInfiniteDesktopView && !isInLightbox && !isView360State && (React.createElement(GalleryCounter, { isRightToLeft: isRightToLeft, currentItem: currentIndex + 1, amount: galleryData.length })),
        React.createElement(GalleryItemContainerStyled, { hasPadding: hasPadding, isInLightbox: isInLightbox, isSquareRatio: isSquareRatio },
            isControlsAvailable && isPrevVisible && (React.createElement(ControlButtonStyled, { buttonVariant: FADED_VARIANT, hasIconButton: ICON_ONLY, iconComponent: ChevronLeft, onClick: isRightToLeft ? showNext : showPrev, isPrev: true, colorSchema: BTN_DARK_THEME, label: previous, size: SIZE_48, hasContainerPadding: hasPadding, isVideo: isVideo })),
            React.createElement(GalleryTrackStyled, { onTouchStart: touchStartHandler, onTouchMove: touchMoveHandler, onPointerDown: pointerDownHandler, onPointerUp: pointerUpHandler, onKeyDown: keyPressHandler, tabIndex: 0, isInLightbox: isInLightbox, isSquareRatio: isSquareRatio, ref: isInLightbox ? galleryTrackRef : null },
                React.createElement(GalleryList, { isInLightbox: isInLightbox, items: galleryData, currentIndex: currentIndex, isDraggable: isDraggable, isRightToLeft: isRightToLeft, addErrorItem: addErrorItem, isErrorItem: isErrorItem, isZoomed: isZoomed })),
            isControlsAvailable && isNextVisible && (React.createElement(ControlButtonStyled, { buttonVariant: FADED_VARIANT, hasIconButton: ICON_ONLY, iconComponent: ChevronRight, onClick: isRightToLeft ? showPrev : showNext, colorSchema: BTN_DARK_THEME, label: next, size: SIZE_48, hasContainerPadding: hasPadding, isView360: isView360State, isVideo: isVideo }))),
        React.createElement(InfoContainer, { isInLightbox: isInLightbox, isImage: isImage, photoDisclaimers: photoDisclaimers, downloadButtonLabel: downloadButtonLabel, onDownload: () => onDownloadImage(currentImageURL), isRightToLeft: isRightToLeft }),
        Boolean(lightboxThumbnails?.length || thumbnailsList?.length) && (React.createElement(GalleryThumbnails, { thumbnailAspectRatio: thumbnailAspectRatio, items: isInLightbox ? lightboxThumbnails : thumbnailsList, thumbnailsAmount: thumbnailsAmount, thumbnailsIndent: thumbnailsIndent, onShowItem: showItem, isRightToLeft: isRightToLeft, currentIndex: currentIndex, hasPadding: hasPadding, isInLightbox: isInLightbox })),
        React.createElement(Lightbox, null)));
}
export const Gallery = memo(GalleryComponent);
